<div class="main-dashboard-container" [class.search-active]="selectedTabIndex === 1" cdkDropListGroup>

  <aside class="sidebar-left">
    <div class="tab-content-wrapper">

      <!-- TOP SEARCH BAR & ADD FOLDER (Identiek aan Lists setup) -->
      <div class="sidebar-top-bar">
        <div class="tab-header-actions search-mode" [class.adding-folder]="isAddingRoot">
          <ng-container *ngIf="isAddingRoot">
            <mat-form-field appearance="outline" class="compact-form-field">
              <input matInput #rootValue placeholder="New folder name..." (keyup.enter)="saveRootItem(rootValue.value)"
                (keyup.escape)="isAddingRoot = false" autofocus>
              <div matSuffix class="inline-actions">
                <button mat-icon-button (click)="saveRootItem(rootValue.value)"><mat-icon>check</mat-icon></button>
                <button mat-icon-button (click)="isAddingRoot = false"><mat-icon>close</mat-icon></button>
              </div>
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="!isAddingRoot">
            <mat-form-field appearance="outline" class="compact-form-field search-field">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput #searchInput placeholder="Search notes..." (input)="onSearch(searchInput.value)"
                (keyup.escape)="clearSearch(searchInput)">

              <button matSuffix mat-icon-button [style.visibility]="searchInput.value ? 'visible' : 'hidden'"
                (click)="clearSearch(searchInput)">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

          </ng-container>
        </div>
      </div>

      <!-- SIDEBAR CONTENT WITH CALENDAR SECTIONS -->
      <div class="tree-wrapper">
        <div class="category-group" *ngFor="let cal of calendars">

          <!-- SECTIE HEADER (Klikbaar gemaakt voor collapse/expand) -->
          <div class="category-header" (click)="toggleCalendarSection(cal)" (dragover)="$event.preventDefault()"
            (drop)="handleDropOnCalendarOrFolder($event, cal.id)">

            <!-- Pijltje voor visualisatie van open/dicht state -->
            <mat-icon class="expand-icon">
              {{ isCalendarExpanded(cal.id) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>

            <mat-icon class="cal-header-icon" [style.color]="cal.color || '#3b82f6'">calendar_today</mat-icon>
            <span class="category-title">{{ getCalendarLabel(cal) }}</span>

            <!-- Spinner wanneer de notities voor deze kalender geladen worden -->
            <mat-progress-spinner *ngIf="loadingCalendars.has(cal.id)" mode="indeterminate" diameter="16">
            </mat-progress-spinner>

            <button mat-icon-button class="cal-action-btn" (click)="$event.stopPropagation()"
              [matMenuTriggerFor]="calMenu" matTooltip="Calendar options">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #calMenu="matMenu" class="compact-menu">
              <button mat-menu-item (click)="addFolderToCalendar(cal)">
                <mat-icon>create_new_folder</mat-icon>
                <span>Add folder</span>
              </button>
              <button mat-menu-item (click)="hideCalendar(cal)">
                <mat-icon>visibility_off</mat-icon>
                <span>Hide calendar</span>
              </button>
              <button mat-menu-item [matMenuTriggerFor]="colorPickerMenu">
                <mat-icon>palette</mat-icon>
                <span>Set color</span>
              </button>
            </mat-menu>

            <!-- Submenu met de ColorPickerComponent -->
            <mat-menu #colorPickerMenu="matMenu" class="direct-color-menu">
              <div class="color-grid" (click)="$event.stopPropagation()">
                <button *ngFor="let color of calendarColors" class="color-dot" [style.background-color]="color"
                  [class.selected]="color === cal.color" (click)="onCalendarColorChange(cal, color)">
                </button>
              </div>
            </mat-menu>

          </div>

          <!-- SECTIE INHOUD (Alleen zichtbaar als de kalender geopend is) -->
          <div class="category-content" *ngIf="isCalendarExpanded(cal.id)">
            <ng-container
              *ngTemplateOutlet="nodeTemplate; context: { $implicit: getFilteredNotes(cal.id), calId: cal.id }">
            </ng-container>

            <div class="no-items-label"
              *ngIf="(getFilteredNotes(cal.id).length === 0) && !loadingCalendars.has(cal.id)">
              <span style="padding-left: 20px">No notes found</span>
            </div>
          </div>

        </div>
      </div>

    </div>
  </aside>

  <!-- RECURSIEVE LIST TEMPLATE VOOR MAPPEN/NOTITIES -->
  <ng-template #nodeTemplate let-nodes let-calId="calId">
    <ng-container *ngFor="let node of nodes">

      <ng-container *ngIf="isNodeMatching(node, searchQuery)">
        <!-- BESTAAND ITEM (MAP OF NOTITIE) -->
        <div class="mat-tree-node" [class.folder-row]="node.noteType === 'folder'"
          [class.is-active]="selection.isSelected(node)" draggable="true" [attr.data-id]="node.id"
          (dragstart)="handleDragStart($event, node, calId)" (dragover)="$event.preventDefault()"
          (drop)="handleDropOnCalendarOrFolder($event, calId, node)" (click)="onNodeClick(node)">

          <mat-icon class="node-icon">
            {{ node.noteType === 'folder' ? (isFolderExpanded(node.id) ? 'folder_open' : 'folder') : getNodeIcon(node) }}
          </mat-icon>

          <span class="node-text">{{ node.title }}</span>

          <!-- Plus knop om notitie aan deze map toe te voegen -->
          <div class="node-actions" *ngIf="canAdd(node)">
            <button mat-icon-button class="btn-node-edit" (click)="addNewItem(node); $event.stopPropagation()">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>

        <!-- SUB-ITEMS CONTAINER VAN EEN MAP -->
        <div class="sub-items-container" *ngIf="node.noteType === 'folder' && isFolderExpanded(node.id)">

          <!-- 1. RENDERT HET DYNAMISCHE INVOERVELD (SLECHTS EENMALIG ALS DIT DE ACTIEVE MAP IS) -->
          <div class="mat-tree-node inline-edit-node" *ngIf="addingNoteParentId === node.id">
            <mat-icon class="node-icon">subject</mat-icon>
            <mat-form-field appearance="outline" class="compact-form-field">
              <input matInput #newItemInput placeholder="New note title..."
                (keyup.enter)="saveNewItem(node, newItemInput.value)" (keyup.escape)="cancelAddingItem()" autofocus>
              <div matSuffix class="inline-actions">
                <button mat-icon-button
                  (click)="saveNewItem(node, newItemInput.value)"><mat-icon>check</mat-icon></button>
                <button mat-icon-button (click)="cancelAddingItem()"><mat-icon>close</mat-icon></button>
              </div>
            </mat-form-field>
          </div>

          <!-- 2. RECURSIEVE LIJST VAN BESTAANDE NOTITIES IN DE MAP -->
          <ng-container *ngIf="node.notes?.length">
            <ng-container
              *ngTemplateOutlet="nodeTemplate; context: { $implicit: node.notes, calId: calId }"></ng-container>
          </ng-container>

        </div>
      </ng-container>
    </ng-container>
  </ng-template>

  <main class="editor-column">
    <header class="editor-header">
      <div class="title-section">
        <mat-icon class="header-type-icon" *ngIf="currentNote">{{currentNoteIsFolder ? 'folder' :
          'description'}}</mat-icon>
        <h2 class="note-title">{{currentNote?.title || 'Select a note'}}</h2>
      </div>

      <div class="editor-actions" *ngIf="currentNote && !currentNote.systemFolder">
        <button mat-icon-button *ngIf="currentNote.dirty" (click)="saveNote(currentNote)" matTooltip="Save"><mat-icon
            color="primary">save</mat-icon></button>
        <button *ngIf="recordingStatus==='stopped' && hasRevisions" mat-icon-button (click)="showRevisions()"
          matTooltip="Revisions"><mat-icon>restore_page</mat-icon></button>
        <button *ngIf="!currentNoteIsFolder" mat-icon-button (click)="addTask()"
          matTooltip="Add Task"><mat-icon>add_task</mat-icon></button>
        <button *ngIf="recordingStatus==='stopped'" mat-icon-button (click)="onRename()"
          matTooltip="Rename"><mat-icon>title</mat-icon></button>
        <button *ngIf="recordingStatus==='stopped'" mat-icon-button (click)="onDelete()"
          matTooltip="Delete"><mat-icon>delete</mat-icon></button>
        <button *ngIf="recordingStatus==='stopped' && !currentNoteIsFolder" mat-icon-button (click)="onArchive()"
          matTooltip="Archive">
          <mat-icon>{{archived ? 'unarchive' : 'archive'}}</mat-icon>
        </button>
        <button mat-icon-button *ngIf="!currentNoteIsFolder" (click)="mail()"
          matTooltip="Mail notes"><mat-icon>mail_outline</mat-icon></button>

        <ng-container *hasFeature="'AIRECORDING'">
          <div class="recording-controls-group" *ngIf="!currentNoteIsFolder">
            <div class="vertical-divider"></div>

            <!-- Timer (alleen zichtbaar tijdens opname) -->
            <span class="recording-timer" *ngIf="recordingStatus!=='stopped'">
              <span [ngClass]="recordingStatus === 'recording' ? 'recording-dot' : 'stopped-recording-dot'"></span>
              {{ recordingDuration || '00:00' }}
            </span>

            <!-- Play / Pause Knoppen -->
            <button *ngIf="recordingStatus !=='recording'" mat-icon-button (click)="start_recording()"
              matTooltip="Start recording">
              <mat-icon>play_arrow</mat-icon>
            </button>
            <button *ngIf="recordingStatus==='recording'" mat-icon-button (click)="pause_recording()"
              matTooltip="Pause recording">
              <mat-icon>pause</mat-icon>
            </button>

            <!-- Stop Knop -->
            <button mat-icon-button (click)="stop_recording()" [disabled]="recordingStatus==='stopped'"
              matTooltip="Stop recording">
              <mat-icon>stop</mat-icon>
            </button>
          </div>
        </ng-container>
      </div>
    </header>

    <div class="editor-content-area">
      <div class="document-paper">
        <div *ngIf="currentNote && !currentNoteIsFolder" class="tiptap-wrapper">
          <!-- Custom Toolbar -->
          <div class="ck-style-toolbar" *ngIf="editor">

            <!-- Heading Selector -->
            <div class="toolbar-group">
              <select (change)="onHeadingChange($event)" class="heading-select">
                <option value="p" [selected]="editor.isActive('paragraph')">Paragraph</option>
                <option value="1" [selected]="editor.isActive('heading', { level: 1 })">Heading 1</option>
                <option value="2" [selected]="editor.isActive('heading', { level: 2 })">Heading 2</option>
                <option value="3" [selected]="editor.isActive('heading', { level: 3 })">Heading 3</option>
              </select>
            </div>

            <div class="divider"></div>

            <!-- Formatting: Bold, Italic, Link, Code -->
            <div class="toolbar-group">
              <button type="button" (click)="editor.chain().focus().toggleBold().run()"
                [class.active]="editor.isActive('bold')" title="Bold">
                <mat-icon>format_bold</mat-icon>
              </button>
              <button type="button" (click)="editor.chain().focus().toggleItalic().run()"
                [class.active]="editor.isActive('italic')" title="Italic">
                <mat-icon>format_italic</mat-icon>
              </button>
            </div>

            <div class="divider"></div>

            <!-- Lists -->
            <div class="toolbar-group">
              <button type="button" (click)="editor.chain().focus().toggleBulletList().run()"
                [class.active]="editor.isActive('bulletList')" title="Bullet List">
                <mat-icon>format_list_bulleted</mat-icon>
              </button>
              <button type="button" (click)="editor.chain().focus().toggleOrderedList().run()"
                [class.active]="editor.isActive('orderedList')" title="Numbered List">
                <mat-icon>format_list_numbered</mat-icon>
              </button>
            </div>

            <div class="divider"></div>

            <!-- Alignment -->
            <div class="toolbar-group">
              <button type="button" (click)="editor.chain().focus().setTextAlign('left').run()"
                [class.active]="editor.isActive({ textAlign: 'left' })" title="Align Left">
                <mat-icon>format_align_left</mat-icon>
              </button>
              <button type="button" (click)="editor.chain().focus().setTextAlign('right').run()"
                [class.active]="editor.isActive({ textAlign: 'right' })" title="Align Right">
                <mat-icon>format_align_right</mat-icon>
              </button>
            </div>

            <div class="divider"></div>

            <!-- Tables, Quotes, Codeblock -->
            <div class="toolbar-group">
              <button type="button" (click)="editor.chain().focus().toggleBlockquote().run()"
                [class.active]="editor.isActive('blockquote')" title="Blockquote">
                <mat-icon>format_quote</mat-icon>
              </button>
              <button type="button" (click)="editor.chain().focus().toggleCodeBlock().run()"
                [class.active]="editor.isActive('codeBlock')" title="Code Block">
                <mat-icon>integration_instructions</mat-icon>
              </button>
            </div>

            <div class="divider"></div>

            <!-- Undo & Redo -->
            <div class="toolbar-group">
              <button type="button" (click)="editor.chain().focus().undo().run()" [disabled]="!editor.can().undo()"
                title="Undo">
                <mat-icon>undo</mat-icon>
              </button>
              <button type="button" (click)="editor.chain().focus().redo().run()" [disabled]="!editor.can().redo()"
                title="Redo">
                <mat-icon>redo</mat-icon>
              </button>
            </div>

            <div class="divider"></div>

            <!-- Media: Image -->
            <div class="toolbar-group">
              <button type="button" (click)="addImage()" title="Insert Image">
                <mat-icon>image</mat-icon>
              </button>
            </div>

          </div>
          <div #editorElement class="tiptap-editor-content"></div>
        </div>
        <div class="readonly-view" *ngIf="!currentNote || currentNoteIsFolder" [innerHTML]=""></div>
      </div>
    </div>
  </main>

  <aside class="sidebar-right" *ngIf="selectedTabIndex === 0">
    <div class="sidebar-header">
      <span class="header-label">Upcoming Events</span>
      <button mat-icon-button (click)="getUpcomingEvents()" matTooltip="Sync Calendar" [disabled]="isSyncing"
        class="sync-btn">
        <mat-icon [class.spinning]="isSyncing">sync</mat-icon>
      </button>
      <button mat-icon-button [matMenuTriggerFor]="filterMenu" #filterMenuTrigger="matMenuTrigger" aria-label="Filter">
        <mat-icon>filter_list</mat-icon>
      </button>

      <!-- Dropdown Menu -->
      <mat-menu #filterMenu="matMenu" class="event-filter-panel">
        <div class="filter-panel-content" (click)="$event.stopPropagation()">

          <!-- 1. Kalender Dropdown (mat-select) -->
          <mat-form-field appearance="outline" class="full-width-field">
            <mat-label>Calendar</mat-label>
            <mat-select [value]="selectedCalendarForEventOverview" [compareWith]="functions.objectComparisonFunction"
              (selectionChange)="onCalendarSelectChange($event.value); filterMenuTrigger.closeMenu()">
              <mat-option *ngFor="let cal of filterCalendars" [value]="cal">
                {{ getCalendarLabel(cal) }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>
      </mat-menu>

    </div>

    <div class="loader-container">
      <mat-progress-bar mode="indeterminate" *ngIf="isSyncing"></mat-progress-bar>
    </div>

    <div class="list-wrapper">
      <div class="event-list">
        <div *ngFor="let upcoming of upcomingEvents" (click)="selectNoteForEvent(upcoming)" class="event-card"
          [ngClass]="upcoming.status" [ngStyle]="getEventCardStyle(upcoming.calendarColor)">

          <div class="status-bar"></div>

          <div class="event-body">
            <div class="event-main">
              <mat-icon class="status-mini-icon">{{getResponseIcon(upcoming.status)}}</mat-icon>
              <span class="event-name">{{upcoming.title}}</span>
            </div>

            <div class="event-time">
              <mat-icon>access_time</mat-icon>
              <span>{{upcoming.startDate | date:'EEE d MMM · HH:mm'}}</span>
            </div>
          </div>
        </div>

        <div *ngIf="upcomingEvents?.length === 0" class="empty-state">
          <mat-icon>event_busy</mat-icon>
          <p>No upcoming events</p>
        </div>
      </div>
    </div>
  </aside>

</div>